module.exports = __webpack_public_path__ + "img/finman-logo.e8e599ab.png";